<template>
    <HeaderContent title="Paket"/>
    <ActionContent :filter-date="false" ctaText="Paket" @action="modal = !modal "/>
    <PackageForm :modal="modal"  @update:modal="modal = $event"></PackageForm>
    <PackageDetail :data-detail="modalDetailData" :modal="modalDetail" @update:modal="modalDetail = $event"></PackageDetail>
    <DataTable :data="data" :header="header" :currentPage="currentPage" :custom-actions="customActions"></DataTable>
</template>

<script>
import { ref,} from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import DataTable from '@/components/DataTable.vue';
import { paket } from '@/dummy-data/paket'
import PackageDetail from './action/PackageDetail.vue';
import PackageForm from './PackageForm.vue';

export default {
    name : 'PackageIndex',
    components : {
        HeaderContent,
        ActionContent,
        PackageForm,
        DataTable,
        PackageDetail
    },
    setup(){
        const modal = ref(false)
        const modalDetail = ref(false)
        const modalDetailData = ref([])
        const currentPage = ref(1)
        const data = paket
        const header = [
            {key : 'id', label : 'Id',sortable: true,},
            {key : 'name', label : 'Name',sortable: true,class:'text-left'},
            {key : 'pax', label : 'Pax',sortable: true,},
            {key : 'duration', label : 'Duration (day)',sortable: true,},
            {key : 'price', label:'Price',sortable: true,},
            {key : 'action', label:'Action'}
        ]
        const customActions = ref([
        {
            label: 'Detail',
            variant: 'secondary',
            icon: 'fas fa-ellipsis-v',
            action: (item) => {
                modalDetail.value = !modalDetail.value
                modalDetailData.value = item.detail
            }
        },
        
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        
      ]);

        return {
            modal,
            modalDetail,
            modalDetailData,
            customActions,
            currentPage,
            data,
            header
        }
    }
}

</script>